<template>
  <div class="pop-up" @touchmove.prevent>
    <transition name="fade">
      <div v-if="mask" class="mask" @touchmove.prevent></div>
    </transition>
    <transition name="fade">
      <div class="pop-up-center" v-if="config.type === 'center'">
        <div class="confirm-contact color-bg-1">
          <p class="color-text-1">
            {{config.title}}
          </p>
          <span class="color-text-3">
            {{config.descMessage}}
          </span>
          <div class="button color_bg_action">
            <div
              class="cancel color_bg_action color-text-dismiss"
              @click="cancel"
            >
              {{config.cancelButtonText}}
            </div>
            <div
              class="confirm color_bg_action color-text-confirm"
              @click="confirm"
            >
              {{config.confirmButtonText}}
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="pop-up-center" v-if="config.type === 'alert'">
        <div class="confirm-contact color-bg-1">
          <p class="color-text-1">
            {{config.title}}
          </p>
          <span class="color-text-3" v-html="config.descMessage"></span>
          <div class="button color_bg_action">
            <div
              class="alert-confirm color_bg_action color-text-confirm"
              @click="confirm"
            >
              {{config.confirmButtonText}}
            </div>
          </div>
        </div>
      </div>
      <div class="pop-up-center" v-if="config.type === 'alert-qrcode'">
        <div class="confirm-contact confirm-contact_alert-qrcode color-bg-1">
          <p class="color-text-1"> {{config.title}} </p>
          <span class="color-text-3" v-html="config.descMessage"></span>
          <img class="qrcode" src="./../../../assets/img/qrcode.png" alt="">
          <i>长按扫码或截图保存</i>
          <div class="button color_bg_action">
            <div class="alert-confirm color_bg_action color-text-confirm" @click="confirm"> {{config.confirmButtonText}} </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slide">
      <div class="pop-up-bottom" v-if="config.type === 'bottom'"
        :style="[containerBottomOffsetStyle]">
        <div class="pop-up-bottom-contact color-bg-1">
          <p class="color-text-3">{{config.descMessage}}</p>
          <span class="color-devider-2"></span>
          <div class="button color_bg_action">
            <div
              class="confirm color-bg-3 color-text-stress"
              @click="confirm"
            >
              {{config.confirmButtonText}}
            </div>
            <div
              class="cancel color_bg_action color-text-dismiss"
              @click="cancel"
            >
              {{config.cancelButtonText}}
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// 加载组件
export default {
  name: 'Popup',
  data() {
    return {
      mask: false,
      config: {},
    };
  },
  computed: {
    containerBottomOffsetStyle() {
      return {
        bottom: this.config.bottomoffset,
      };
    },
  },
  methods: {
    openPopup(config) {
      this.mask = true;
      this.config = config;
    },
    cancel() {
      this.config.cancel();
    },
    confirm() {
      this.config.confirm();
    },
    closePopup() {
      this.mask = false;
      this.config = {};
    },
  },
};
</script>

<style>
.confirm-contact span span {
  color: #F13F3F;
}
</style>

<style scoped>

.pop-up-center {
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 10000;
  transform: translate(-50%, -60%);
}

.pop-up .mask {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  opacity: 0.4;
  background: #040812;
}

.pop-up .pop-up-bottom.slide-enter {
  transform: translateY(100%) translateZ(0);
}

.pop-up .pop-up-bottom.slide-leave {
  transform: translateY(0) translateZ(0);
}

.pop-up .pop-up-bottom.slide-enter-active,
.pop-up .pop-up-bottom.slide-leave-active {
  transition: transform 0.18s ease;
}

.pop-up .pop-up-bottom.slide-enter-to {
  transform: translateY(0) translateZ(0);
}

.pop-up .pop-up-bottom.slide-leave-to {
  transform: translateY(100%) translateZ(0);
}

.confirm-contact {
  width: 5.64rem;
  overflow: hidden;
  border-radius: 0.24rem;
  box-shadow: 0 0.04rem 0.12rem rgba(0, 0, 0, 0.04);
}

.confirm-contact p {
  width: 4.8rem;
  margin: 0.5rem auto 0.22rem;
  text-align: center;
  line-height: 0.42rem;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 0.36rem;
}

.confirm-contact span {
  width: 4.8rem;
  margin: 0 auto 0.22rem 0.5rem;
  display: block;
  letter-spacing: 0.04rem;
  text-align: center;
  font-size: 0.32rem;
  font-family: HYQiHei;
  font-weight: normal;
  color: #A6A3B5;
  line-height: 0.47rem;
}
.confirm-contact i {
  font-style: normal;
  font-size: 0.24rem;
  font-family: HYQiHei;
  font-weight: normal;
  color: #A6A3B5;
  line-height: 0.24rem;
  text-align: center;
  display: block;
  margin-bottom: 0.43rem;
}
.confirm-contact_alert-qrcode span {
  text-align: left;
}

.qrcode {
  width: 1.7rem;
  height: 1.7rem;
  display: block;
  margin: 0.38rem auto 0.14rem;
  font-size: 0;
}

.confirm-contact .button {
  width: 100%;
  height: 1.1rem;
  text-align: center;
  line-height: 1.1rem;
}

.confirm-contact .button .confirm,
.confirm-contact .button .cancel {
  width: 50%;
  height: 1.1rem;
  margin: 0;
  padding: 0;
  border: 0;
  outline: none;
  text-align: center;
  float: left;
  line-height: 1.1rem;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 0.32rem;
}
.alert-confirm {
  width: 100%;
  height: 1.1rem;
  margin: 0;
  padding: 0;
  border: 0;
  outline: none;
  text-align: center;
  float: left;
  line-height: 1.1rem;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 0.32rem;
}
.pop-up-bottom-contact span {
  width: 6.3rem;
  height: 0.02rem;
  margin: 0 auto;
  display: block;
}
.pop-up-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  transform: translateY(0) translateZ(0);
}
.pop-up-bottom-contact {
  width: 7.02rem;
  margin: 0 auto;
  border-radius: 0.24rem;
  overflow: hidden;
}
.pop-up-bottom-contact p{
  width: 100%;
  height: 1rem;
  text-align: center;
  line-height: 1rem;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 0.24rem;
}
.pop-up-bottom-contact .button .confirm,
.pop-up-bottom-contact .button .cancel {
  width: 100%;
  height: 1.1rem;
  margin: 0;
  padding: 0;
  border: 0;
  outline: none;
  text-align: center;
  line-height: 1.1rem;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 0.32rem;
}
</style>
